import { render, staticRenderFns } from "./DirectorShareholding.vue?vue&type=template&id=5b1420bc"
import script from "./DirectorShareholding.vue?vue&type=script&lang=js"
export * from "./DirectorShareholding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports